import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import InstallPrompt from "@/components/InstallPrompt";
import { registerSW } from "@/lib/registerSW";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import UploadAnalysis from "@/pages/UploadAnalysis";
import BulkUpload from "@/pages/BulkUpload";
import AnalysisDetail from "@/pages/AnalysisDetail";
import Workers from "@/pages/Workers";
import WorkerDetail from "@/pages/WorkerDetail";
import Report from "@/pages/Report";
import Billing from "@/pages/Billing";
import BillingSuccess from "@/pages/BillingSuccess";
import Settings from "@/pages/Settings";
import Team from "@/pages/Team";
import AcceptInvite from "@/pages/AcceptInvite";

registerSW();

function AppRouter() {
  const location = useLocation();
  // Synchronous check for OAuth callback fragment — process FIRST, before any other route
  if (location.hash && location.hash.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/dashboard/upload" element={<ProtectedRoute><UploadAnalysis /></ProtectedRoute>} />
      <Route path="/dashboard/upload-bulk" element={<ProtectedRoute><BulkUpload /></ProtectedRoute>} />
      <Route path="/dashboard/workers" element={<ProtectedRoute><Workers /></ProtectedRoute>} />
      <Route path="/dashboard/workers/:id" element={<ProtectedRoute><WorkerDetail /></ProtectedRoute>} />
      <Route path="/dashboard/analysis/:id" element={<ProtectedRoute><AnalysisDetail /></ProtectedRoute>} />
      <Route path="/dashboard/report" element={<ProtectedRoute><Report /></ProtectedRoute>} />
      <Route path="/dashboard/billing" element={<ProtectedRoute><Billing /></ProtectedRoute>} />
      <Route path="/dashboard/billing/success" element={<ProtectedRoute><BillingSuccess /></ProtectedRoute>} />
      <Route path="/dashboard/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
      <Route path="/dashboard/team" element={<ProtectedRoute><Team /></ProtectedRoute>} />
      <Route path="/accept-invite/:token" element={<AcceptInvite />} />
      <Route path="*" element={<Landing />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <InstallPrompt />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
